import { ErrorResponse } from '@makyoapp/makyo-sdk/api/api'

export function formatError(err: string | ErrorResponse | Error) {
  let message = 'Something went wrong...'
  let status = 503

  if (typeof err === 'string') {
    message = err
  } else if (err instanceof ErrorResponse) {
    message = err.message
    status = err.status
  } else {
    message = err.message
  }

  return { message, status }
}
